import { render, staticRenderFns } from "./mail-list.vue?vue&type=template&id=d6bedc6e&scoped=true&"
import script from "./mail-list.vue?vue&type=script&lang=js&"
export * from "./mail-list.vue?vue&type=script&lang=js&"
import style0 from "./mail-list.vue?vue&type=style&index=0&id=d6bedc6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6bedc6e",
  null
  
)

export default component.exports